'use strict';

var regexCheck = require('../util/regex-check.js');
var asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
module.exports = asciiHexDigit;